import React from "react";
import { t } from "i18next";
import AppStandardButton from "../../components/UI/AppButtons";
import { useNavigate, useSearchParams } from "react-router-dom";

export function BookingConfirmationPayPal() {
  const [searchParams] = useSearchParams();
  const isSmallScreen = window.innerWidth <= 768;

  const getSelectedVehicleImage = () => {
    const queryImage = searchParams.get("selectedVehicleImage");
    return queryImage && queryImage !== ""
      ? queryImage
      : localStorage.getItem(`${searchParams.get("resId")}:vehicleImage`);
  };

  const selectedVehicleImage = getSelectedVehicleImage();
  localStorage.removeItem(`${searchParams.get("dbId")}:vehicleImage`);

  return (
    <>
      {isSmallScreen}
      <section
        className={`min-h-[80vh] box-border ${
          !isSmallScreen ? "px-44" : ""
        } flex flex-col border-t-2 border-solid border-grey-300 relative`}
        style={{
          minHeight: "100vh",
          width: "100%",
          backgroundImage: `url(${selectedVehicleImage})`,
          backgroundPosition: "center",
          backgroundColor: "black",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

        <header
          className={`grow flex flex-col box-border py-8 z-10 ${
            !isSmallScreen ? "gap-4" : ""
          }`}
          style={{
            paddingTop: "12rem",
            paddingLeft: isSmallScreen ? "25px" : "",
          }}
        >
          <ConfirmationText isSmallScreen={isSmallScreen} />
          <ButtonsGroup isSmallScreen={isSmallScreen} />
        </header>

        <footer className="text-gray-600 box-border pb-32"></footer>
      </section>
    </>
  );
}

// Reusable Component for Confirmation Text
const ConfirmationText = ({ isSmallScreen }: { isSmallScreen: boolean }) => {
  const textStyle = {
    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
    fontSize: isSmallScreen ? "24px" : "48px",
  };

  return (
    <>
      <h1 className="text-3xl text-white" style={textStyle}>
        {t("Congratulations!")}
      </h1>
      <h1
        className="text-3xl text-white"
        style={{ ...textStyle, marginTop: isSmallScreen ? "-8px" : "" }}
      >
        {t("Your Reservation Has Been Successful")}
      </h1>
      <h1
        className="text-white"
        style={{
          fontFamily: "MBCorpoSText-Regular-Web-new",
          fontSize: isSmallScreen ? "18px" : "28px",
          marginTop: isSmallScreen ? "-5px" : "",
        }}
      >
        {t("You can check it on your Personal Area")}
      </h1>
    </>
  );
};

// Reusable Component for Buttons
const ButtonsGroup = ({ isSmallScreen }: { isSmallScreen: boolean }) => {
  const navigateTo = useNavigate();
  return (
    <div className="flex flex-row gap-4">
      <AppStandardButton
        href="/embed"
        className="w-fit py-4"
        variant="outlined"
        color="white"
        style={{ width: "134.87px", height: "40.64px" }}
      >
        <span
          className="normal-case text-white p-1"
          style={{
            fontWeight: "300",
            fontSize: isSmallScreen ? "12px" : "15px",
            fontFamily: isSmallScreen
              ? "MBCorpoSTitle-Bold-Web-new"
              : "MBCorpoSText-CondRegular-Web",
          }}
        >
          Homepage
        </span>
      </AppStandardButton>
      <AppStandardButton
        href="/myReservedBookings"
        className="w-fit py-4"
        color="primary"
        variant="contained"
        style={{ width: "162.45px", height: "40.64px" }}
        onClick={() => navigateTo("/profile")}
      >
        <span
          className="normal-case text-white p-1"
          style={{
            fontWeight: "300",
            fontSize: isSmallScreen ? "12px" : "15px",
            fontFamily: isSmallScreen
              ? "MBCorpoSTitle-Bold-Web-new"
              : "MBCorpoSText-CondRegular-Web",
          }}
        >
          My Profile
        </span>
      </AppStandardButton>
    </div>
  );
};
